<template>
    <div>
        <Filtres @filter-change="onFilterChange" :nb-results="eventsFiltered.length || 0"/>
        <div class="limiter">

            <div v-if="evenements && evenements.pageInfo.hasNextPage" class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-py-28">
                <v-progress-linear
                    class="tw-w-96"
                    color="primary accent-4"
                    :value="progressValue"
                    rounded
                    height="6"
                    indeterminate
                ></v-progress-linear>
                <span class="tw-mt-4 text-1-8 tw-font-bold tw-uppercase tw-text-center">Chargement des événements</span>
            </div>

            <EventsListing v-else-if="eventsFiltered && eventsFiltered.length > 0" :events="eventsFiltered"/>

            <div v-else class="tw-py-28">
                <p class="text-1-8 tw-font-bold tw-uppercase tw-text-center">Aucun résultat</p>
            </div>
        </div>
    </div>
</template>

<script>
import EventsListing from "./EventsListing";
import evenementsGql from "@/queries/CarteEvenements.graphql"
import Filtres from "./Filtres";
import moment from "moment";

export default {
    name: "PublicEvents",
    components: {Filtres, EventsListing},
    data() {
        return {
            pageIndex : null,
            eventsFetched : [],
            events : null,
            eventsFiltered : null,
        }
    },
    apollo: {
        evenements: {
            query : evenementsGql,
            variables() {
                return {
                    after : this.pageIndex
                }
            }
        }
    },
    watch : {
        evenements: function (newValue, oldValue) {
            if(oldValue && oldValue.pageInfo.endCursor === newValue.pageInfo.endCursor) {
                return false
            }
            this.eventsFetched = this.eventsFetched.concat(newValue.nodes);
            if(newValue.pageInfo.hasNextPage) {
                this.pageIndex = newValue.pageInfo.endCursor
            }
            this.checkEventsDates(this.eventsFetched)
        }
    },
    methods : {

        checkEventsDates(events) {
            let listeComplete = []
            let programmeComplet = []
            events.forEach((event) => {
                const nbDates = event.acfEvent.dates.length

                if (nbDates > 1) {

                    const horaires = event.acfEvent.dates.slice();

                    for(let i = 0; i < nbDates; i++) {
                        let eventClone = JSON.parse(JSON.stringify(event))
                        let horaire = horaires[i]
                        eventClone.acfEvent.dates = [horaire]
                        programmeComplet.push(eventClone)
                    }
                } else {
                    programmeComplet.push(event)
                }

            })


            const programmeOrdered = programmeComplet.sort(function(a,b){
                return new Date(moment(a.acfEvent.dates[0].dateDebut, "DD-MM-YYYY")).getTime() - new Date(moment(b.acfEvent.dates[0].dateDebut, "DD-MM-YYYY")).getTime();
            });

            const liste = programmeOrdered.filter( event => event.acfEvent.dates[0])

            const chunkSize = 1;
            for (let i = 0; i < liste.length; i += chunkSize) {
                const chunk = liste.slice(i, i + chunkSize);
                listeComplete.push(chunk[0])
            }

            this.events = listeComplete
            this.eventsFiltered = listeComplete.filter( event => this.checkFilterYear(new Date().getFullYear() , event) )

        },

        onFilterChange(filters) {
            if(filters.dates.length === 0 && filters.regions.length === 0 && filters.tags.length === 0) {
                this.eventsFiltered = this.events.filter( event => this.checkFilterYear(filters.year , event) )

            }
            const eventsFiltered = this.events.filter( event => this.checkFilterYear(filters.year , event) && this.checkFilterRegion(filters.regions , event) && this.checkFilterDate(filters.dates , event) && this.checkFilterTag(filters.tags , event) )
            this.eventsFiltered = eventsFiltered
        },

        checkFilterYear(filterYear , event) {


            const eventYear = (moment(event.acfEvent.dates[0].dateDebut, "DD-MM-YYYY")).year()

            if(filterYear === eventYear) {
                return true
            }

            return false


        },

        checkFilterDate(filterDates , event) {
            if(filterDates.length === 0) return true

            if(event.acfEvent.dates[0].dateFin) {

                for (const date of filterDates) {
                    const dateToCheck = (moment(date, "DD-MM-YYYY"))
                    const startingDate = (moment(event.acfEvent.dates[0].dateDebut, "DD-MM-YYYY"))
                    const endingDate = (moment(event.acfEvent.dates[0].dateFin, "DD-MM-YYYY"))

                    const checkIsBetween = moment(dateToCheck).isBetween( startingDate, endingDate , undefined , [])
                    if(checkIsBetween) {
                        return true
                    }
                }
                return false
            }

            return filterDates.includes(event.acfEvent.dates[0].dateDebut)
        },

        checkFilterRegion(filterRegions , event) {
            if(filterRegions.length === 0) return true
            if(event.regions.nodes.length === 0) return false
            if(filterRegions.includes('metropole')) {
                if (event.regions.nodes[0].parentDatabaseId === 6) return true
            }
            return filterRegions.includes(event.regions.nodes[0].termTaxonomyId)
        },

        checkFilterTag(filterTags , event) {
            if(filterTags.length === 0) return true
            if(event.types.nodes.length === 0) return false
            return event.types.nodes.some(r => filterTags.includes(r.termTaxonomyId))
            // return filterTags.includes(event.types.nodes[0].termTaxonomyId)
        },

    },

}
</script>

<style scoped>

</style>